import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminCalendar from "@/pages/admin/AdminCalendar";

export const Route = createFileRoute("/admin/calendar")({
  component: () => (
    <ProtectedRoute>
      <AdminCalendar />
    </ProtectedRoute>
  ),
});
